import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {TextArea} from '@components/textarea'
import {keyboardHandler, noPropagate, useClickAway} from '@containers/hooks'
import {useStore} from '../subtasks-store'

const TwTextArea = tw(TextArea)<{$withoutHover?: boolean}>`
  ${p =>
    p.$withoutHover
      ? `shadow-none focus:shadow-none hover:shadow-none`
      : `shadow-task-old focus:shadow-task-old hover:bg-project-hover-old`}
  min-h-64
  overflow-hidden
  cursor-text
  leading-main
  text-main-old
  text-14
  border-solid
  border-main-old
  border
  rounded-4
  bg-main-old
  w-full
  box-border
  px-12
  py-8
  focus:border-main-old
  focus:bg-main-old
  m-0
`

export const NewTaskEditorInput = observer(
  (props: {
    stayOpen: boolean
    withoutHover?: boolean
    onEndAdd?: () => void
  }) => {
    const [state, store] = useStore()
    const ref = useRef<HTMLInputElement | null>(null)
    const onClickOutside = () => {
      if (state.newTaskTitle.length > 0) {
        store.createNewTask()
      }
      store.setShowNewTaskInput(false)
      props?.onEndAdd?.()
    }
    useClickAway(ref, onClickOutside)
    return (
      <TwTextArea
        ref={ref}
        autoFocus
        onKeyDown={keyboardHandler({
          enter: () => {
            store.createNewTask()
            !props.stayOpen && store.setShowNewTaskInput(false)
            //https://bugs.chromium.org/p/chromium/issues/detail?id=32865
            setTimeout(() => {
              store.setNewTaskTitle('')
            }, 0)
            return true
          },
          escape: () => {
            store.setShowNewTaskInput(false)
            props?.onEndAdd?.()
            return true
          }
        })}
        onBlur={onClickOutside}
        onMouseDown={noPropagate}
        value={state.newTaskTitle}
        onChange={e => {
          store.setNewTaskTitle(e.target.value)
        }}
        placeholder={Lang.msg.subtask.enterTitle}
        $withoutHover={props.withoutHover}
      />
    )
  }
)
